// March Madness campaign tier logic, shared across frontend, backend, and email
// All end dates are midnight Pacific Time (PDT in March 2026, UTC-7)
const MARCH_MADNESS_TIERS = [
    {
        loons: 32,
        bracketName: 'Round of 32',
        multiplier: '8x',
        multiplierNumber: 8,
        endLabel: 'March 11',
        end: new Date('2026-03-12T07:00:00Z'),
    },
    {
        loons: 16,
        bracketName: 'Sweet 16',
        multiplier: '4x',
        multiplierNumber: 4,
        endLabel: 'March 22',
        end: new Date('2026-03-23T07:00:00Z'),
    },
    {
        loons: 8,
        bracketName: 'Elite 8',
        multiplier: '2x',
        multiplierNumber: 2,
        endLabel: 'March 31',
        end: new Date('2026-04-01T07:00:00Z'),
    },
];
const getMarchMadnessActiveTierIndex = (now) => {
    for (let i = 0; i < MARCH_MADNESS_TIERS.length; i++) {
        if (now < MARCH_MADNESS_TIERS[i].end)
            return i;
    }
    return -1;
};
export const getMarchMadnessActiveTier = (now) => {
    const index = getMarchMadnessActiveTierIndex(now);
    return index >= 0 ? MARCH_MADNESS_TIERS[index] : null;
};
//# sourceMappingURL=marchMadness.js.map